import React from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { TestimonialsHero } from './components/TestimonialsHero';
import { PainSection } from './components/PainSection';
import { ProductSection } from './components/ProductSection';
import { BonosSection } from './components/BonosSection';
import { OfferSection } from './components/OfferSection';
import { SecondaryTestimonials } from './components/SecondaryTestimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-full bg-cream font-serif text-[#1a1a1a]" data-id="element-0">
      <Hero data-id="element-1" />
      <StatsBar data-id="element-2" />
      <TestimonialsHero data-id="element-3" />
      <PainSection data-id="element-4" />
      <ProductSection data-id="element-5" />
      <BonosSection data-id="element-6" />
      <OfferSection data-id="element-7" />
      <SecondaryTestimonials data-id="element-8" />
      <GuaranteeSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}